module.exports = __webpack_public_path__ + "img/diashow (5).e718f5a.jpg";